module.exports = __webpack_public_path__ + "img/PP.0b8d474d.jpg";